/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FeedCalendarComponentDisplay } from "cms/components/components/feed-calendar/display";
import { FeedCalendarComponentEditor } from "cms/components/components/feed-calendar/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

function FeedCalendarComponent (props) {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <FeedCalendarComponentDisplay />,
        editComponent: <FeedCalendarComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
}

FeedCalendarComponent.displayName = "FeedCalendarComponent";
export { FeedCalendarComponent };
